import React, {useRef, useState, createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {noop} from '@salesforce/retail-react-app/app/utils/utils'

const GigyaModalContext = createContext(null)

export const GigyaModalProvider = ({children}) => {
    const [isOpen, setIsOpen] = useState(false)
    const [isNotifyMe, setIsNotifyMe] = useState(false)
    const [notifiedProducts, setNotifiedProducts] = useState({})
    const callbackRef = useRef(null)

    const openModal = (notifyMe = false, callback = noop) => {
        setIsNotifyMe(notifyMe)
        callbackRef.current = callback
        setIsOpen(true)
    }
    const closeModal = () => setIsOpen(false)

    const toggleNotifyProduct = (productId) => {
        setNotifiedProducts((prev) => ({
            ...prev,
            [productId]: !prev[productId],
        }))
    }
    const isProductNotified = (productId) => !!notifiedProducts[productId]

    return (
        <GigyaModalContext.Provider
            value={{
                isOpen,
                isNotifyMe,
                openModal,
                closeModal,
                toggleNotifyProduct,
                isProductNotified,
                callback: callbackRef.current,
            }}
        >
            {children}
        </GigyaModalContext.Provider>
    )
}

GigyaModalProvider.propTypes = {
    children: PropTypes.node.isRequired,
}

export const useGigyaModal = () => useContext(GigyaModalContext)
